import { Grid, Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { Person } from '@mui/icons-material';

export function GHEFormThirdStep({ pessoas }) {
    return (
        <Grid container spacing={3}>
            {pessoas && pessoas.length > 0 ? (
                pessoas.map((pessoa, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            elevation={2}
                            sx={{
                                height: '100%',
                                transition: 'all 0.3s',
                                '&:hover': {
                                    elevation: 6,
                                    transform: 'translateY(-4px)'
                                }
                            }}
                        >
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Person color="primary" sx={{ mr: 1 }} />
                                    <Typography variant="h6" component="h3">
                                        {pessoa.nome}
                                    </Typography>
                                </Box>

                                <Chip
                                    label={`Matrícula: ${pessoa.matricula}`}
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                />

                                <Chip
                                    label={`Tipo de usuário: ${pessoa.tipoUsuario}`}
                                    color="primary"
                                    variant="outlined"
                                    size="small"
                                    sx={{ ml: 2 }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                ))
            ) : (
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="body1" color="text.secondary" align="center">
                                Nenhum colaborador cadastrado neste grupo.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Grid>
    );
}